import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AutorizacionService } from './autorizacion.service';
import { AlertasService } from '../utilidades/alertas.service';

/**
 * Guardian que verifica si el usuario tiene acceso a la página solicitada.
 * @author Juan Corral
 */
export const autorizacionGuard: CanActivateFn = async (route, state) => {
  const autorizacionService = inject(AutorizacionService);
  const alertasService = inject(AlertasService);

  const autorizacion = route.data['autorizacion'] ?? {};
  const autorizado = await autorizacionService.tieneAutorizacion$(autorizacion);
  if (!autorizado) {
    alertasService.alertarError(
      'No tienes autorización para acceder a esta página',
    );
    return false;
  }

  return true;
};
